import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

// 🎨 Palette de couleurs modernes et néons pour ton thème sombre
const COULEURS_CATEGORIES = {
  'Administratif': '#c24242',
  'Autres': '#a0a0b0',
  'Alimentation': '#00d2ff',
  'Assurance voiture': '#f00fa9',
  'Essence': '#00ff66',
  'Facture': '#ff0000',
  'Google Play App': '#bff00f',
  'Loisirs': '#ffc107',
  'Loyer': '#ff007f',
  'Personnel': '#f0e80f',
  'Tabac': '#a0a0b0',
  'Santé': '#a9c1c0',
  'Téléphone mobile': '#9472dc',
  'Voiture': '#6e6e68'
};

const FinancesPieChart = ({ transactions }) => {
  
  // 🧮 1. FONCTION DE CALCUL : Regroupe tes dépenses par catégorie
  const preparerDonneesGraphique = () => {
    const dictionnaire = {};

    transactions.forEach(t => {
      const montantOriginal = parseFloat(t.amount) || 0;

      // 🎯 LE VERROU EXCLUSIF : On définit ce qui est STRICTEMENT une dépense
      // (Soit le chiffre a un signe moins, soit son type est explicitement un débit)
      const estUneDepense =
        montantOriginal < 0 ||
        t.type === 'debit' ||
        t.type === 'Sortie' ||
        t.nature === 'debit'; // Ajoute ici le mot exact que tu as mis pour tes débits

      if (estUneDepense) {
        const cat = t.category || t.categorie || 'Autres';
        // On prend la valeur positive (la valeur absolue) pour l'ajouter au graphique
        const valeurAbsolue = Math.abs(montantOriginal);

        if (valeurAbsolue > 0) {
          dictionnaire[cat] = (dictionnaire[cat] || 0) + valeurAbsolue;
        }
      }
    });

    // Transformation au format attendu par Recharts
    return Object.keys(dictionnaire).map(cat => ({
      name: cat,
      value: Math.round(dictionnaire[cat] * 100) / 100
    }));
  };

  const data = preparerDonneesGraphique();

  // 🛡️ Sécurité : Si l'utilisateur n'a encore enregistré aucune dépense ce mois-ci
  if (data.length === 0) {
    return (
      <div className="text-center text-warning p-4 border border-secondary border-opacity-25 rounded-3 bg-dark bg-opacity-20">
        📉 Aucune dépense enregistrée pour le moment.
      </div>
    );
  }

  return (
    <div className="bg-dark bg-opacity-50 border border-secondary border-opacity-25 rounded-3 p-3 shadow-lg h-100">
      <h5 className="text-light fw-semibold mb-3 text-center text-md-start tracking-wide" style={{ fontSize: '1rem' }}>
        📊 Répartition des Dépenses
      </h5>
      
      {/* 📏 ResponsiveContainer permet au graphique de s'ajuster tout seul sur Mobile */}
      <div style={{ width: '100%', height: 260 }}>
        <ResponsiveContainer>
          <PieChart>
            <Tooltip 
              contentStyle={{ backgroundColor: '#1a1a24', borderWidth: '2px', borderColor: '#ffc107', borderRadius: '8px', color: '#fff' }}
              itemStyle={{ color: '#fff' }}
              formatter={(value) => [`${value.toFixed(2)} €`, 'Total']}
            />
            <Legend 
              verticalAlign="bottom" 
              height={36} 
              iconType="circle"
              wrapperStyle={{ fontSize: '12px', fontWeight: '500', color: '#a0a0b0' }}
            />
            <Pie
              data={data}
              cx="50%"
              cy="45%"
              innerRadius={60}  // 🎯 C'est ce rayon interne qui transforme le cercle en DONUT !
              outerRadius={85}
              paddingAngle={0}
              dataKey="value"
              strokeWidth={2}    // 📏 Épaisseur de la bordure en pixels
              // stroke="#1a1a24"   // 🎨 Couleur de la bordure (mets la même couleur que le fond de ton bloc bg-dark)
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`} 
                  fill={COULEURS_CATEGORIES[entry.name] || COULEURS_CATEGORIES['📦 Autres']} 
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default FinancesPieChart;
